/**
 * Utility to prefetch images by injecting <link rel="prefetch"> tags into the document head
 * This eliminates delays when images are needed during scroll
 *
 * @param imageUrls - Array of image URLs to prefetch
 */
export const prefetchImages = (imageUrls: string[]): void => {
  if (!imageUrls || imageUrls.length === 0) {
    return;
  }

  const head = document.head || document.getElementsByTagName('head')[0];

  imageUrls.forEach((url) => {
    // Check if prefetch link already exists
    const existingLink = head.querySelector(`link[href="${url}"]`);
    if (existingLink) {
      return;
    }

    // Create and inject prefetch link
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'image';
    link.href = url;

    head.appendChild(link);
  });
};
